export const LOAD_CAMPAIGNS = 'Dyzio/CampaignList/LOAD_CAMPAIGNS';
export const LOAD_CAMPAIGNS_SUCCESS = 'Dyzio/CampaignList/LOAD_CAMPAIGNS_SUCCESS';
export const LOAD_CAMPAIGNS_ERROR = 'Dyzio/CampaignList/LOAD_CAMPAIGNS_ERROR';
export const SET_CAMPAIGN_PERMISSION = 'Dyzio/CampaignList/SET_CAMPAIGN_PERMISSION';

export const SET_PERMISSION_STATUS = 'Dyzio/Campaign/SET_PERMISSION_STATUS';
export const UPDATE_PERMISSION = 'Dyzio/Campaign/UPDATE_PERMISSION';

export const UPDATE_SHOW_CAMPAIGNS_LIST = 'Dyzio/Campaign/UPDATE_SHOW_CAMPAIGNS_LIST';



/** WEBPACK FOOTER **
 ** ./src/containers/influencers-campaign-list/constants.js
 **/